<mat-toolbar class="footer">
  <ta-button color="neutral" appearance="outline" (click)="contactSupport()">
    <ta-icon fontIcon="help-circle" size="xxs"></ta-icon>
    {{ 'Shell.Footer.Support' | translate }}
  </ta-button>
  <ta-button color="neutral" appearance="outline" (click)="navigateToWiki(tecComWikiUri, true)">
    <ta-icon fontIcon="book-open-01" size="xxs"></ta-icon>
    {{ 'Shell.Footer.Wiki' | translate }}
  </ta-button>
  <ta-button *ngIf="isAuthenticated$ | async" color="neutral" appearance="ghost" class="hide-large" (click)="navigateTo(legacyWebinarUri, true)">
    {{ 'Shell.Footer.Webinars' | translate }}
  </ta-button>
  <ta-button *ngIf="isAuthenticated$ | async" color="neutral" appearance="ghost" class="hide-large" (click)="navigateTo(releaseNotesUri, true)">
    {{ 'Shell.Footer.ReleaseNotes' | translate }}
  </ta-button>
  <ta-button color="neutral" appearance="ghost" (click)="navigateTo(statusPageUri, true)">
    {{ 'Shell.Footer.SystemStatus' | translate }}
  </ta-button>
  <ta-button color="neutral" appearance="ghost" class="hide-large" (click)="navigateTo(legacyLegalNotice, true)">
    {{ 'Shell.Footer.LegalNotice' | translate }}
  </ta-button>
  <ta-button color="neutral" appearance="ghost"  (click)="navigateTo(tecallianceWebSite, true)">
    {{ 'Shell.Footer.Website' | translate }}
  </ta-button>
  <ta-button color="neutral" appearance="ghost"  (click)="openCookieSettings()">
    {{ 'Shell.Footer.CookieSettings' | translate }}
  </ta-button>
  <span class="spacer"></span>
  <!-- Theme switcher hidden - kept for future re-enablement -->
  <ng-container *ngIf="false">
    <ta-button color="neutral" appearance="ghost" leadingIcon="circle-cut" tsc-beta [matMenuTriggerFor]="themeMenu">
      {{ 'Shell.Footer.Theme.' + (theme$ | async) | translate }}
      <ta-badge color="orange" appearance="solid">{{ 'Shell.Common.Beta' | translate }}</ta-badge>
    </ta-button>
    <mat-menu #themeMenu="matMenu">
      <div mat-menu-item *ngFor="let theme of themeType | keyvalue"  (click)="setTheme(theme.value)">
        {{ 'Shell.Footer.Theme.' + theme.value | translate }}
      </div>
    </mat-menu>
  </ng-container>
  <div data-test-id="languageSelector">
    <ta-button color="neutral" appearance="ghost" leadingIcon="globe-06" [matMenuTriggerFor]="langMenu">
      {{ (currentLanguageItem$ | async)?.label! | translate }}
    </ta-button>
    <mat-menu class="language-menu" #langMenu="matMenu" xPosition="before">
      <button mat-menu-item *ngFor="let language of (language$ | async)?.supported"
        (click)="languageChanged(language.value)">
        <span class="mfe-navigation-menu-item">
          <img class="language-flag" [src]="language.flag" alt="flag" />
          {{ language.label | translate }}
        </span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
